const MRT_Localization_SV = {
    actions: 'Åtgärder',
    and: 'och',
    cancel: 'Avbryt',
    changeFilterMode: 'Ändra filterläge',
    changeSearchMode: 'Ändra sökläge',
    clearFilter: 'Rensa filter',
    clearSearch: 'Rensa sök',
    clearSelection: 'Rensa val',
    clearSort: 'Rensa sortering',
    clickToCopy: 'Klicka för att kopiera',
    copy: 'Kopiera',
    collapse: 'Stäng',
    collapseAll: 'Stäng alla',
    columnActions: 'Kolumnåtgärd',
    copiedToClipboard: 'Kopierade till urklipp',
    dropToGroupBy: 'Släpp för att grupp efter {column}',
    edit: 'Redigera',
    expand: 'Expandera',
    expandAll: 'Expandera alla',
    filterArrIncludes: 'Inkluderar',
    filterArrIncludesAll: 'Inkluderar alla',
    filterArrIncludesSome: 'Inkluderar',
    filterBetween: 'Mellan',
    filterBetweenInclusive: 'Mellan inklusive',
    filterByColumn: 'Filtrera efter {column}',
    filterContains: 'Innehåller',
    filterEmpty: 'Tom',
    filterEndsWith: 'Slutar med',
    filterEquals: 'Lika med',
    filterEqualsString: 'Lika med',
    filterFuzzy: 'Fuzzy',
    filterGreaterThan: 'Större än',
    filterGreaterThanOrEqualTo: 'Större än eller lika med',
    filterInNumberRange: 'Mellan',
    filterIncludesString: 'Innehåller',
    filterIncludesStringSensitive: 'Innehåller',
    filterLessThan: 'Mindre än',
    filterLessThanOrEqualTo: 'Mindre än eller lika med',
    filterMode: 'Filterläge: {filterType}',
    filterNotEmpty: 'Inte Tom',
    filterNotEquals: 'Inte lika med',
    filterStartsWith: 'Börjar med',
    filterWeakEquals: 'Lika med',
    filteringByColumn: 'Filtrering efter {column} - {filterType} {filterValue}',
    goToFirstPage: 'Gå till första sidan',
    goToLastPage: 'Gå till sista sidan',
    goToNextPage: 'Gå till nästa sida',
    goToPreviousPage: 'Gå till föregående sida',
    grab: 'Greppa',
    groupByColumn: 'Gruppera efter {column}',
    groupedBy: 'Gruppera efter ',
    hideAll: 'Göm alla',
    hideColumn: 'Göm {column} kolumn',
    max: 'Max',
    min: 'Minst',
    move: 'Flytta',
    noRecordsToDisplay: 'Inget att visa',
    noResultsFound: 'Inga resultat funna',
    of: 'av',
    or: 'eller',
    pin: 'Fäst',
    pinToLeft: 'Fäst till vänster',
    pinToRight: 'Fäst till höger',
    resetColumnSize: 'Återställ kolumnstorlek',
    resetOrder: 'Återställ ordning',
    rowActions: 'Radåtgärder',
    rowNumber: '#',
    rowNumbers: 'Radnummer',
    rowsPerPage: 'Rader per sida',
    save: 'Spara',
    search: 'Sök',
    selectedCountOfRowCountRowsSelected: '{selectedCount} av {rowCount} rad(er) valda',
    select: 'Välj',
    showAll: 'Visa alla',
    showAllColumns: 'Visa alla kolumner',
    showHideColumns: 'Visa/Göm kolumner',
    showHideFilters: 'Visa/Göm filter',
    showHideSearch: 'Visa/Göm sök',
    sortByColumnAsc: 'Sortera efter {column} stigande',
    sortByColumnDesc: 'Sortera efter {column} nedåtgående',
    sortedByColumnAsc: 'Sorterat efter {column} stigande',
    sortedByColumnDesc: 'Sorterat efter {column} nedåtgående',
    thenBy: ', sedan av ',
    toggleDensity: 'Växla densitet',
    toggleFullScreen: 'Växla helskärm',
    toggleSelectAll: 'Växla välja alla',
    toggleSelectRow: 'Växla välj rad',
    toggleVisibility: 'Växla synlighet',
    ungroupByColumn: 'Avgruppera efter {column}',
    unpin: 'Avfäst',
    unpinAll: 'Avfäst alla',
};

export { MRT_Localization_SV };
